import React, { useEffect, useState } from 'react'

import { EasyParinagePage } from './easyParinagePage'
import UpdateMonProfile from './updateMonProfile'
import { UpdatePassWord } from './updateProfile'

interface props {
  code?: any
}

const SettingProfileSecondPart: React.FC<props> = ({ code }) => {

  const number = parseInt(code)
  const [isLink, setIsLink] = useState(number)
  const liste = ['Mon Profil', 'Mon Easy Parrainage', 'Changer mon mot de passe']

  const handleTextClick = (number: any) => {
    setIsLink(number)
  }

  return (
    <div>
      <div className=" px-[10%] lg:px-0 flex justify-between items-center sm:items-baseline border-b  border-b-[#E2E2FB]">

        {liste.map((item, index) => (
          <div key={index}
            className={` w-[250px] lg:w-full h-12 sm:h-[55px]   py-2 text-center text-[14px]  font-semibold  hover:cursor-pointer
          ${isLink === index ? 'text-[#5754E5] border-b-2 border-b-[#5754E5]  bg-[#F1F1FF]/50' : 'text-[#AEB6FB]'}`}
            onClick={() => handleTextClick(index)}
          >
            {item}
          </div>
        ))}
      </div>

      {isLink === 0 ? (
        <UpdateMonProfile/>
       
      ) : isLink === 1 ? (
        <EasyParinagePage />
      ) : (
        <UpdatePassWord/>
      )}
    </div>
  )
}
export default SettingProfileSecondPart